<template>
  <div>
    <div class="modal fade" id="registerModalToggle" aria-hidden="true" aria-labelledby="registerModalToggleLabel"
      tabindex="-1" data-bs-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" :style="skin.my_account.main_background">
          <div class="modal-header" style="border-bottom: none">
            <button :style="skin.my_account.close_btn" style="background: none" type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="Close">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div class="text-center p-2">
                <img v-if="skin.header_desktop.logo != ''" :src="skin.header_desktop.logo"
                  :width="skin.header_desktop.login_logo_width" alt="" /><br /><br />

                <span class="text-light">{{ translate("new_user") }}</span><br />
                <span class="text-light">{{ translate("register_easy") }}</span><br /><br />
              </div>
              <div v-if="status.result != 'OK'" class="alert alert-danger" role="alert">
                {{ status.msg }}
              </div>
              <form @submit.prevent="nextStep()">
                <div class="mb-3">
                  <label class="text-light text-left" for="registerUsername">                    
                    {{userNameLabel}}                    
                  </label>
                  <input v-model.trim="new_user_data.username" type="text" minlength="5" id="registerUsername"
                    class="form-control" :class="{ 'is-invalid': errors.username }"
                    :placeholder="translate('enter_username')" aria-label="registerUsername"
                    aria-describedby="registerUsername" autocomplete="username" required
                    @input="errors.username = ''" />
                  <div class="invalid-feedback" v-if="errors.username">{{ errors.username }}</div>
                </div>
                <div class="mb-3">
                  <label class="text-light" for="RegisterPassword">{{
                    translate("password")
                  }}</label>
                  <input v-model="new_user_data.password" id="RegisterPassword" type="password" minlength="6"
                    class="form-control" :class="{ 'is-invalid': errors.password }"
                    :placeholder="translate('enter_password')" aria-label="RegisterPassword"
                    aria-describedby="RegisterPassword" autocomplete="new-password" required
                    @input="errors.password = ''" />
                  <div class="invalid-feedback" v-if="errors.password">{{ errors.password }}</div>
                </div>
                <button type="submit" :style="skin.qbet.booking_btn" class="p-2 text-center mb-2"
                  style="width: 100%; color: white">
                  {{ translate("confirm") }}
                </button>
                <button data-bs-target="#registerModalToggle2" data-bs-toggle="modal" data-bs-dismiss="modal"
                  id="nextForm" style="display: none"></button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="registerModalToggle2" aria-hidden="true" aria-labelledby="registerModalToggleLabel2"
      tabindex="-1" data-bs-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" :style="skin.my_account.main_background">
          <div class="modal-header" style="border-bottom: none">
            <h5 class="text-light">{{ translate("end_registration") }}</h5>
            <button id="closeRegister" :style="skin.my_account.close_btn" style="background: none" type="button"
              class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <div v-if="status.result != 'OK'" class="alert alert-danger" role="alert">
                {{ status.msg }}
              </div>
              <form @submit.prevent="register()">
                <div v-if="skin.register_fields.idn" class="mb-3">
                  <label class="text-light" for="registerId">{{
                    translate("idn")
                  }}</label>&nbsp;
                  <span v-if="cpf_loading" class="spinner-border" :style="skin.loader" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                  <span v-if="
                    skin.register_fields.cpf_verification && cpf_message != ''
                  " v-html="cpf_message" style="
                      color: #842029;
                      background-color: #f8d7da;
                      border-color: #f5c2c7;
                      border: 1px solid transparent;
                      border-radius: 0.25rem;
                    " class="px-2"></span>
                  <input v-model="idn" type="text" id="registerId" class="form-control"
                    :class="{ 'is-invalid': errors.idn }" :placeholder="translate('enter_here')"
                    pattern="^[a-zA-Z0-9_]{5,}$" aria-label="registerId" aria-describedby="registerId"
                    @input="errors.idn = ''" @blur="handleIdnChange" />
                  <div class="invalid-feedback" v-if="errors.idn">{{ errors.idn }}</div>
                </div>
                <div v-if="skin.register_fields.name" class="mb-3">
                  <label class="text-light" for="registerFirstName">{{ translate("name") }}</label>
                  <input v-model="new_user_data.firstname" type="text" id="registerFirstName" class="form-control"
                    :class="{ 'is-invalid': errors.firstname }" :placeholder="translate('enter_here')"
                    aria-label="registerFirstName" aria-describedby="registerFirstName"
                    :readonly="skin.register_fields.cpf_verification" required @input="errors.firstname = ''" />
                  <div class="invalid-feedback" v-if="errors.firstname">{{ errors.firstname }}</div>
                </div>
                <div v-if="skin.register_fields.last_name" class="mb-3">
                  <label class="text-light" for="registerLastName">{{
                    translate("last_name")
                  }}</label>
                  <input v-model="new_user_data.last_name" type="text" id="registerLastName"
                    pattern="^[a-zA-Z0-9_]{3,}$" class="form-control" :class="{ 'is-invalid': errors.last_name }"
                    :placeholder="translate('enter_here')" aria-label="registerLastName"
                    aria-describedby="registerLastName" required @input="errors.last_name = ''" />
                  <div class="invalid-feedback" v-if="errors.last_name">{{ errors.last_name }}</div>
                </div>
                <div v-if="skin.register_fields.second_last_name" class="mb-3">
                  <label class="text-light" for="registerSecondLastName">
                    {{ secondLastNameLabel }}
                  </label>
                  <input v-model="new_user_data.second_lastname" type="text" id="registerSecondLastName"
                    pattern="^[a-zA-Z0-9_]{3,}$" class="form-control" @blur="errors.second_lastname = ''" :class="{ 'is-invalid': errors.second_lastname }"
                    :placeholder="translate('enter_here')" aria-label="registerSecondLastName"
                    aria-describedby="registerSecondLastName" required @input="errors.second_lastname = ''" />
                  <div class="invalid-feedback" v-if="errors.second_lastname">{{ errors.second_lastname }}</div>
                </div>
                <div v-if="skin.register_fields.cpf_verification" class="mb-3">
                  <label class="text-light" for="birthday">{{
                    translate("birthday")
                  }}</label>
                  <input v-model="birthday" type="text" id="birthday" class="form-control" placeholder="Dia/Mês/Ano"
                    aria-label="birthday" aria-describedby="birthday" readonly />
                </div>
                <div v-if="skin.register_fields.name" class="mb-3">
                  <label class="text-light" for="registeremail">{{
                    translate("email")
                  }}</label>
                  <input v-model="new_user_data.email" type="email" id="registeremail" class="form-control"
                    :class="{ 'is-invalid': errors.email }" :placeholder="translate('enter_here')"
                    aria-label="registeremail" aria-describedby="registeremail" required @input="errors.email = ''" />
                  <div class="invalid-feedback" v-if="errors.email">{{ errors.email }}</div>
                </div>
                <div v-if="skin.register_fields.country" class="mb-3">
                  <label class="text-light" for="registerCountry">{{
                    translate("country")
                  }}</label>
                  <select class="form-control" name="country" v-model="new_user_data.country" id="registerCountry"
                    required>
                    <option v-for="(country, index) in countries" :key="index" :value="country.code">
                      {{ currentLanguage == "es" ? country.name_es : country.name_en }}
                    </option>
                  </select>
                </div>
                <div v-if="skin.register_fields.currency" class="mb-3">
                  <label class="text-light" for="registerCurrency">{{
                    translate("currency")
                  }}</label>
                  <select class="form-control" name="currency" v-model="new_user_data.currency" id="registerCurrency"
                    required>
                    <option v-for="currency in currencies" :key="currency" :value="currency">
                      {{ currency }}
                    </option>
                  </select>
                </div>
                <div v-if="skin.register_fields.phone_number" class="mb-3">
                  <label class="text-light" for="registerCurrency">{{
                    translate("phone")
                  }}</label>&nbsp;&nbsp;<span v-if="!phone_code_checked" style="
                      color: #842029;
                      background-color: #f8d7da;
                      border-color: #f5c2c7;
                      border: 1px solid transparent;
                      border-radius: 0.25rem;
                    " class="px-2">{{ translate("incorrect_code") }}</span>
                  <div class="d-flex">
                    <div class="input-group me-1" style="width: 40%">
                      <span class="input-group-text" id="basic-addon1">+</span>
                      <input :style="!phone_code_checked ? 'border-color:red;' : ''" type="number" v-model="phone_code"
                        class="form-control" :placeholder="translate('country_code')"
                        :disabled="skin.register_fields.default_phone_code != 0" />
                    </div>
                    <div style="width: 60%">
                      <input v-model.trim="new_user_data.phone" type="tel" pattern="[0-9]{7,15}" class="form-control"
                        :class="{ 'is-invalid': errors.phone }" :placeholder="translate('enter_number')" required
                        @input="errors.phone = ''" />
                      <div class="invalid-feedback" v-if="errors.phone">{{ errors.phone }}</div>
                    </div>
                  </div>
                </div>
                <div class="form-check mb-3">
                  <input class="form-check-input" type="checkbox" value="" v-model="agreement" required />
                  <label class="form-check-label text-light" for="flexCheckDefault">
                    {{ translate("aggrement") }}
                    <span @click="terms()" class="link-primary">{{
                      translate("see_aggrement")
                    }}</span>
                  </label>
                </div>
                <div class="text-center">
                  <span v-if="register_inProcess" class="spinner-border" :style="skin.loader" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                </div>
                <button type="submit" :style="skin.qbet.confirm_btn" class="p-2 text-center mb-2"
                  style="width: 100%; color: white" :disabled="register_inProcess">
                  {{ translate("confirm") }}
                </button>
                <button type="button" :style="skin.qbet.booking_btn" class="btn btn-primary" style="width: 100%"
                  data-bs-target="#registerModalToggle" data-bs-toggle="modal" data-bs-dismiss="modal">
                  {{ translate("back") }}
                </button>
              </form>
              <button data-bs-target="#registerModalToggle3ganamos" data-bs-toggle="modal" data-bs-dismiss="modal"
                style="display: none" id="registerSuccessfull"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="registerModalToggle3ganamos" aria-hidden="true"
      aria-labelledby="registerModalToggleLabel3" tabindex="-1" data-bs-backdrop="false"
      style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" :style="skin.my_account.main_background">
          <div class="modal-header" style="border-bottom: none">
            <button :style="skin.my_account.close_btn" style="background: none" type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="Close">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center p-2">
              <span style="font-size: 64px; color: green"><i class="fas fa-check-circle"></i></span><br />
              <span>{{ translate("register_success") }}</span><br />
              <span>{{ translate("can_login") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button data-bs-target="#phoneVericationModal" data-bs-toggle="modal" data-bs-dismiss="modal" style="display: none"
      id="phoneVericationModalBtn"></button>
    <div class="modal fade" id="phoneVericationModal" aria-hidden="true" aria-labelledby="phoneVericationModal"
      tabindex="-1" data-bs-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" :style="skin.my_account.main_background">
          <div class="modal-header" style="border-bottom: none">
            {{ translate("phone_verification") }}
            <button :style="skin.my_account.close_btn" style="background: none" type="button" class="btn-close"
              data-bs-dismiss="modal" aria-label="Close">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <span v-if="phone_verification.loading" class="spinner-border" :style="skin.loader" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
              <div v-else :class="'alert alert-' + phone_verification.message.type" role="alert">
                {{ phone_verification.message.message }}
              </div>
            </div>
            <form v-if="!phone_verification.code_checked" class="text-center p-2" @submit.prevent="verify_phone()">
              <input v-model="phone_verification.code" type="number" step="1" required /><br /><br />
              <button type="submit" :style="skin.qbet.confirm_btn" class="p-2 text-center mb-2"
                style="width: 100%; color: white">
                {{ translate("confirm") }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const countriesData = require("../../../assets/countries.json");
import axios from "axios";
export default {
  name: "register",
  props: ["skin", "translation", "language"],
  data() {
    return {
      selected_country: "",
      email: "",
      password: "",
      first_name: "",
      last_name: "",
      idn: "",
      cpf_message: "",
      cpf_verified: true,
      cpf_loading: false,
      birthday: "",
      gender: "",
      country_code: "",
      phone_code: "52",
      phone_code_checked: true,
      edit_tickets: 0,
      phone_verification: {
        code_checked: false,
        code: "",
        otp_id: "",
        loading: false,
        message: {
          type: "",
          message: "",
        },
      },
      phone: "",
      currency_name: "",
      status: { result: "OK", msg: "" },
      agreement: false,
      register_inProcess: false,
      new_user_data: {
        affiliate_id: "",
        country: "MX",
        type: "",
        username: "",
        email: "",
        firstname: "",
        last_name: "",
        second_lastname: "",
        dni: "",
        password: "",
        phone: "",
        currency: "MXN",
        login_Id: 0,
        poker: 0,
        casino: 0,
        deportes: 0,
        // proveedores: {
        //   poker: { comision: 0,  status: true },
        //   casino: [],
        //   deportes: { status: true, comision: 0 },
        //   bingo: { status: true, comision: 0 },
        //   casinoLive: {  comision: 0, status: true },
        //   hipicas: { status: true, comision: 0 },
        //   casinoTotal: "",
        //   pokerTotal: "",
        //   deportesTotal: "",
        //   bingoTotal: "",
        //   casinoLiveTotal: "",
        //   hipicasTotal: "",
        // },
        error: "",
        liquidacion: "Mensual",
      },
      errors: {
        username: "",
        email: "",
        firstname: "",
        last_name: "",
        second_lastname: "",
        idn: "",
        password: "",
        phone: "",
      }
    };
  },
  computed: {
    getRoot() {
      return this.$store.getters["getRoot"];
    },
    qtag() {
      let data = this.$store.getters["getQtag"];
      return data;
    },
    user() {
      let data = this.$store.getters["getUserData"];
      return data;
    },
    afiliado() {
      let data = this.$store.getters["getAfiliado"];
      // console.log(data)
      return data;
    },
    currentLanguage() {
      return this.$store.getters['getLanguage'];
    },
     
    secondLastNameLabel() {
      const translated = this.translate("second_last_name");
      if (translated && translated !== "second_last_name") return translated;
      
      return this.currentLanguage === 'es' ? 'Segundo Apellido' : this.currentLanguage === 'pt' ? 'Segundo Apelido' : 'Second Last Name';
    },

    userNameLabel() {
      const translated = this.translate("username");
      if (translated && translated !== "username") return translated;
      
      return this.currentLanguage === 'es' ? 'Nombre de Usuario' : this.currentLanguage === 'pt' ? 'Nome de Usuario' : 'Username';
    },


    root() {
      let data = this.$store.getters["getRoot"];
      // console.log(data)
      return data;
    },
    apiUrlnew() {
      const url = this.$store.getters["getApiUrlnew"];

      return url;
    },
    site() {
      return this.$store.getters["getSite"];
    },
    requiresReferral() {
      return this.$props.skin?.register_fields?.requires_referral === true;
    },
    referralRoot() {
      const qtag = String(this.qtag ?? "").trim();
      if (!/^[1-9]\d*$/.test(qtag)) return null;

      const root = Number(qtag);
      return Number.isSafeInteger(root) ? root : null;
    },
    referralRequiredMessage() {
      if (this.currentLanguage === "pt") return "Você deve se registrar através de um link de indicação válido.";
      if (this.currentLanguage === "en") return "You must register through a valid referral link.";
      return "Debes registrarte mediante un enlace de referido válido.";
    },
    currencies() {
      let root = this.$props.skin.register_fields.root;
      if (
        this.$props.skin &&
        this.$props.skin.register_fields &&
        typeof root === 'object'
      ) {
        const keys = Object.keys(root);
        return keys.sort();
      }
      return ["MXN", "PEN", "CLP", "USD"];
    },

    countries() {
      const allowedCurrencies = this.currencies;
      let filteredCountries = countriesData.countries.filter(country =>
        allowedCurrencies.includes(country.currency)
      );
      return filteredCountries.sort((a, b) => {
        const nameA = a[this.currentLanguage == "es" ? "name_es" : "name_en"];
        const nameB = b[this.currentLanguage == "es" ? "name_es" : "name_en"];
        return nameA.localeCompare(nameB, this.currentLanguage);
      });
    },

    // currencies() {

    //     //a partir de register_fields.root que es un obtejo vamos a obtener las currencys, las currencys
    //     //son las claves del objeto root , el objeto root esta dentro de  state.state.skins[0].register_fields.root
    //     //ENTONCES VAMOS HACER ESO
    //     const root = this
    //   const allCurrencies = this.countries().map(c => c.currency);

    //   // Filtramos para que sean únicas y no estén vacías
    //   const uniqueCurrencies = [...new Set(allCurrencies)].filter(curr => curr && curr !== "");

    //   if (uniqueCurrencies.length > 0) {
    //     // Las devuelve ordenadas alfabéticamente
    //     return uniqueCurrencies.sort(); 
    //   }

    //   // Fallback por si el JSON no tiene monedas aún
    //   return ["MXN", "PEN", "CLP", "USD","COP"];
    // },

  },
  methods: {
    capializeFirst(text) {
      if (!text) { return "" }
      return text.charAt(0).toUpperCase() + text.slice(1);
    },

    showReferralRequiredError() {
      this.status.result = "error";
      this.status.msg = this.referralRequiredMessage;
    },

    terms() {
      let url = "";
      let lang =
        this.$props.language == "es"
          ? "spa"
          : this.$props.language == "en"
            ? "eng"
            : this.$props.language == "pt"
              ? "pt-br"
              : "spa";
      if (this.user.prefix == "external") {
        url =
          "https://docs.sistemasw3.com/terms/" +
          lang +
          "/?site=" +
          this.user.site.toUpperCase() +
          "&link=" +
          this.user.site;
      } else {
        let domain_formated = this.user.domain.split("//")[1];
        let domain_name1 = domain_formated.split(".")[1].toUpperCase();
        let domain_name2 =
          domain_formated.split(".")[1] + "." + domain_formated.split(".")[2];
        url =
          "https://docs.sistemasw3.com/terms/" +
          lang +
          "/?site=" +
          domain_name1 +
          "&link=" +
          domain_name2;
      }

      window.open(url, "_blank").focus();
    },
    async register() {
      this.register_inProcess = true;
      // Limpiar errores previos
      Object.keys(this.errors).forEach(key => this.errors[key] = "");
      this.status.msg = "";
      this.status.result = "OK";

      let response;
      try {
        if (this.requiresReferral && this.referralRoot === null) {
          this.showReferralRequiredError();
          this.register_inProcess = false;
          return;
        }

        let loginInfo =
          this.new_user_data.username != "" && this.new_user_data.password != ""
            ? true
            : false;
        if (!loginInfo) {
          this.status.result = "error";
          this.language == "es" ? this.status.msg = "Debes completar los datos de Ingreso" : this.status.msg = "You must complete the login data";
          this.register_inProcess = false;
          return;
        } else {
          let data = {};
          //aca en data country vamos a pasar es el codigo de pais que viene de new_user_data.country que es un objeto
          data.country = this.new_user_data.country;
          data.username = this.new_user_data.username;
          data.email = this.new_user_data.email;
          data.firstname = this.new_user_data.firstname;
          data.lastname = this.new_user_data.last_name;
          data.second_lastname = this.new_user_data.second_lastname;
          data.password = this.new_user_data.password;
          data.phone = this.phone_code + this.new_user_data.phone;
          data.dni = this.idn;
          data.edit_tickets = this.edit_tickets;
          data.root = this.referralRoot ?? this.$props.skin?.register_fields?.root?.[this.new_user_data.currency];

          let endpoint = "user/register";

        
          response = await axios.post(this.apiUrlnew + endpoint, data);

          if (response.data.error) {
            this.register_inProcess = false;
            this.handleServerError(response.data.message || response.data.error);
          } else {
            this.$store.dispatch("storeQtag", data.affiliate_id);
            this.register_inProcess = false;
            document.getElementById("registerSuccessfull").click();
            document.getElementById("closeRegister").click();
            this.resetForm(); // Limpiar después de un registro exitoso
          }
        }
      } catch (error) {
        this.register_inProcess = false;
        const msg = error.response?.data?.message || error.response?.data?.error || "Error al registrar la cuenta.";
        this.handleServerError(msg);
      }
    },
    handleServerError(msg) {
      this.status.result = "error";

      if(Array.isArray(msg)){
        msg = msg[0];
      }

      let displayMsg = msg;
      const lowerMsg = msg.toLowerCase();
      const isEs = this.currentLanguage === 'es';

      // Detectamos el campo afectado y asignamos el mensaje hardcodeado según el idioma
      if (lowerMsg.includes("usuario padre")) {
        displayMsg = isEs ? "Error interno." : this.currentLanguage === 'pt' ? "Erro interno." : "Internal error.";
      }
      else if (lowerMsg.includes("high-risk")) {
        displayMsg = isEs ? "Tu verificación está en proceso. Por el momento no podemos habilitar tu cuenta" : this.currentLanguage === 'pt' ? "Sua verificação está em andamento. No momento, não podemos habilitar sua conta" : "Your verification is in progress. For the moment we cannot enable your account.";
        this.errors.idn = displayMsg;
      }
      else if (lowerMsg.includes("curp")) {
        displayMsg = isEs ? "CURP inválido." : this.currentLanguage === 'pt' ? "CURP inválido." : "Invalid CURP."
      }
      else if (lowerMsg.includes("usuario") || lowerMsg.includes("username")) {
        displayMsg = isEs ? "El nombre de usuario ya existe." : this.currentLanguage === 'pt' ? "Nome de usuário já existe." : "Username already exists.";
        this.errors.username = displayMsg;
      }
      else if (lowerMsg.includes("email") || lowerMsg.includes("correo")) {
        displayMsg = isEs ? "El correo electrónico ya está registrado." : this.currentLanguage === 'pt' ? "Email já registrado." : "Email is already registered.";
        this.errors.email = displayMsg;
      } else if (lowerMsg.includes("password") || lowerMsg.includes("contraseña")) {
        displayMsg = isEs ? "La contraseña no es válida o es muy corta." : this.currentLanguage === 'pt' ? "Senha inválida ou muito curta." : "Invalid or too short password.";
        this.errors.password = displayMsg;
      } else if (lowerMsg.includes("dni") || lowerMsg.includes("documento") || lowerMsg.includes("identificación") || lowerMsg.includes("cpf")) {
        displayMsg = isEs ? "El número de documento ya está registrado." : this.currentLanguage === 'pt' ? "Número de documento já registrado." : "The document number is already registered.";
        this.errors.idn = displayMsg;
      } else if (lowerMsg.includes("nombre") || lowerMsg.includes("firstname")) {
        displayMsg = isEs ? "El nombre ingresado no es válido." : this.currentLanguage === 'pt' ? "Nome inserido inválido." : "The entered name is not valid.";
        this.errors.firstname = displayMsg;
      } else if (lowerMsg.includes("apellido") || lowerMsg.includes("lastname")) {
        displayMsg = isEs ? "El apellido ingresado no es válido." : this.currentLanguage === 'pt' ? "Sobrenome inserido inválido." : "The entered last name is not valid.";
        this.errors.last_name = displayMsg;
      } else if (lowerMsg.includes("segundo apellido") || lowerMsg.includes("second_lastname")) {
        displayMsg = isEs ? "El segundo apellido ingresado no es válido." : this.currentLanguage === 'pt' ? "Sobrenome inserido inválido." : "The entered second last name is not valid.";
        this.errors.second_lastname = displayMsg;
      } else if (lowerMsg.includes("teléfono") || lowerMsg.includes("phone") || lowerMsg.includes("celular")) {
        displayMsg = isEs ? "El número de teléfono ya está registrado o es inválido." : this.currentLanguage === 'pt' ? "Número de telefone já registrado ou inválido." : "The phone number is already registered or invalid.";
        this.errors.phone = displayMsg;
      }

      this.status.msg = displayMsg;
    },
    resetForm() {
      // Reiniciar datos del usuario con valores por defecto
      this.new_user_data = {
        affiliate_id: "",
        country: this.$props.skin.register_fields.default_country || "MX",
        type: "",
        username: "",
        email: "",
        firstname: "",
        last_name: "",
        second_lastname: "",
        dni: "",
        password: "",
        phone: "",
        currency: this.$props.skin.register_fields.default_currency || "MXN",
        login_Id: 0,
        poker: 0,
        casino: 0,
        deportes: 0,
        error: "",
        liquidacion: "Mensual",
      };

      // Reiniciar campos auxiliares
      this.idn = "";
      this.birthday = "";
      this.phone = "";
      this.phone_code = this.$props.skin.register_fields.default_phone_code || "52";
      this.agreement = false;
      this.cpf_message = "";
      this.cpf_verified = true;

      // Reiniciar estados de error y proceso
      this.status = { result: "OK", msg: "" };
      this.register_inProcess = false;

      // Limpiar objeto de errores
      Object.keys(this.errors).forEach(key => this.errors[key] = "");
    },
    async storeQtag(state, payload) {
      document.cookie = `qtag=${payload}; path=/; max-age=31536000`; // Caducidad de 1 día (86400 segundos)
    },

    async verify_dni() {
      try {
        const response = await axios.get(
          "https://admin.eujogo.bet/deposit/bs2/checkdni",
          { params: { dni: this.idn } }
        );

        const data = response.data.data;

        if (data?.nascimento) {
          this.applyDocumentData(data);
          return true;
        }
      } catch (e) { }

      return false;
    },

    async verify_cpf() {
      if (this.$props.skin.register_fields.cpf_verification && this.idn != "") {
        this.cpf_loading = true;
        const response = await axios.get(
          "https://admin.eujogo.bet/deposit/bs2/checkcpf?cpf=" + this.idn
        );
        if (response.data.data.nascimento) {
          const date = response.data.data.nascimento;
          this.new_user_data.firstname = response.data.data.nome;
          this.birthday =
            date.slice(0, 2) + "/" + date.slice(2, 4) + "/" + date.slice(4, 8);
          this.cpf_verified = true;
          this.cpf_loading = false;
          this.cpf_message = "";
        } else {
          this.cpf_message = response.data.data.mensagem;
          this.birthday = "";
          this.cpf_verified = false;
          this.cpf_loading = false;
        }
      }
    },
    handleIdnChange() {
      if (this.skin.register_fields.cpf_verification) {
        this.verify_cpf();
      }
    },
    async send_phone_code(flag) {
      if (flag == 2) {
        this.phone_verification.loading = true;
        let data_phone = {
          command: "verify_phone",
          params: {
            phone: this.new_user_data.phone.replace("+", "").substring(2),
            code: this.new_user_data.phone.replace("+", "").slice(0, 2),
          },
        };
        const response_phone_verification = await axios.post(
          this.user.domain +
          "/" +
          this.user.prefix +
          "/scommand?access_token=" +
          this.user.token +
          "&site=" +
          this.user.site,
          data_phone
        );
        document.getElementById("phoneVericationModalBtn").click();
        this.phone_verification.message.message =
          response_phone_verification.data.message;
        this.phone_verification.message.type = response_phone_verification.data
          .success
          ? "success"
          : "danger";
        this.phone_verification.loading = false;
        return "success";
      } else {
        this.phone_verification.loading = true;
        let phone_data = {
          phone_code: this.phone_code,
          phone: this.phone.replace(".", ""),
          lang: this.$props.language,
        };
        let phone_response = await axios.post(
          "https://jbets.online:3012/api/generate_otp",
          phone_data
        );
        if (
          phone_response.data.otp_id &&
          (phone_response.data.status
            ? phone_response.data.status == "OPEN"
              ? true
              : false
            : false)
        ) {
          this.phone_verification.otp_id = phone_response.data.otp_id;
          document.getElementById("phoneVericationModalBtn").click();
          this.phone_verification.message.message = phone_response.data.message;
          this.phone_verification.message.type = "success";
          this.phone_verification.loading = false;
          this.register_inProcess = false;
          return "success";
        }
        this.register_inProcess = false;
        return "failed";
      }
    },
    async verify_phone() {
      if (this.phone_verification.otp_id == "") {
        this.phone_verification.loading = true;
        let data_phone = {
          command: "check_verify_phone",
          params: { code: this.phone_verification.code },
        };
        const response_phone_verification = await axios.post(
          this.user.domain +
          "/" +
          this.user.prefix +
          "/scommand?access_token=" +
          this.user.token +
          "&site=" +
          this.user.site,
          data_phone
        );
        if (response_phone_verification.data.success) {
          this.phone_verification.message.message =
            response_phone_verification.data.message;
          this.phone_verification.message.type = "success";
          this.phone_verification.code_checked = true;
          this.phone_verification.loading = false;
        } else {
          this.phone_verification.message.message =
            response_phone_verification.data.message;
          this.phone_verification.message.type = "danger";
          this.phone_verification.code_checked = false;
          this.phone_verification.loading = false;
        }
      } else {
        this.phone_verification.loading = true;
        let data_phone = {
          otp_id: this.phone_verification.otp_id,
          code: this.phone_verification.code,
          lang: this.$props.language,
        };
        let phone_response = await axios.post(
          "https://jbets.online:3012/api/verify_otp",
          data_phone
        );
        if (phone_response.data.status) {
          this.phone_verification.message.message = phone_response.data.message;
          this.phone_verification.message.type = "success";
          this.phone_verification.code_checked = true;
          this.phone_verification.loading = false;
          this.phone_verification.otp_id = "";
          this.register();
        } else {
          this.phone_verification.message.message = phone_response.data.message;
          this.phone_verification.message.type = "danger";
          this.phone_verification.code_checked = false;
          this.phone_verification.loading = false;
        }
      }
    },
    nextStep() {
      if (this.requiresReferral && this.referralRoot === null) {
        this.showReferralRequiredError();
        return;
      }

      document.getElementById("nextForm").click();
    },

    translate(text) {
      if (text && this.translation) {
        if (this.translation[text]) {
          return this.translation[text][this.currentLanguage];
        } else {
          var new_text_searched = text.replace(/ /g, "_");
          if (this.translation[new_text_searched]) {
            return this.translation[new_text_searched][this.currentLanguage];
          }
        }
        return text;
      }
      return text;
    },
  },
  watch: {


    phone_code(newVal) {
      let code = "+" + newVal;
      let checkCode = false;
      this.countries.forEach((country) => {
        if (code == country.dial_code) {
          checkCode = true;
        }
      });
      this.phone_code_checked = checkCode;
    },

    'new_user_data.country'(newIsoVal) {

      const selectedCountry = this.countries.find(c => c.code === newIsoVal);

      if (selectedCountry && selectedCountry.currency) {
        this.new_user_data.currency = selectedCountry.currency;
        this.phone_code = selectedCountry.dial_code.replace("+", "");

      }
    },

    'new_user_data.currency'(newCurrVal) {
      // 1. Buscamos el país actual para ver si ya coincide con la nueva moneda
      const currentCountry = this.countries.find(c => c.code === this.new_user_data.country);

      // 2. Si el país que ya está seleccionado NO usa la nueva moneda, buscamos uno que sí
      if (!currentCountry || currentCountry.currency !== newCurrVal) {
        const compatibleCountry = this.countries.find(c => c.currency === newCurrVal);

        if (compatibleCountry) {
          this.new_user_data.country = compatibleCountry.code;
          this.phone_code = compatibleCountry.dial_code.replace("+", "");
        }
      }
    },
    //   'new_user_data.country'(newVal, oldVal) {
    //   console.log('Country changed');
    //   console.log('Anterior:', oldVal);
    //   console.log('Nuevo:', newVal);
    // }, 
  },
  mounted() {

    if (this.$props.skin.register_fields.default_country != "") {
      this.country_code = this.$props.skin.register_fields.default_country;
    }
    if (this.$props.skin.register_fields.default_phone_code != 0) {
      this.phone_code = this.$props.skin.register_fields.default_phone_code;
    }
    if (this.$props.skin.register_fields.default_currency != "") {
      this.currency_name = this.$props.skin.register_fields.default_currency;
    }
    this.$root.$on("send_phone_code", () => {
      this.send_phone_code(2);
    });


    const modalIds = ['registerModalToggle', 'registerModalToggle2', 'registerModalToggle3ganamos'];
    modalIds.forEach(id => {
      const modalElement = document.getElementById(id);
      if (modalElement) {
        modalElement.addEventListener('hidden.bs.modal', () => {
          // Esperamos un momento a que la transición de Bootstrap avance
          setTimeout(() => {
            // Buscamos si alguno de los modales de registro tiene la clase 'show' (está visible)
            const anyOpen = document.querySelector('#registerModalToggle.show, #registerModalToggle2.show, #registerModalToggle3ganamos.show');

            // Si no hay ninguno abierto y no estamos en medio de una petición... ahí sí reseteamos
            if (!anyOpen && !this.register_inProcess) {
              this.resetForm();
            }
          }, 500); // 500ms es tiempo suficiente para que el siguiente modal empiece a mostrarse
        });
      }
    });
  },
};
</script>

<style></style>
